import React from 'react';
import { useTranslation } from 'react-i18next';
import { Preloader, useResponsive } from '@common-fe/common-fe';

import ROUTES from '@/common/routes';
import { useBreadcrumbs } from '@/modules/core/hooks';
import { ManageProfile } from '@/modules/user/components/ManageProfile';
import { useAuthStore } from '@/modules/user/stores';

const ManageAccountPage = () => {
  const { t } = useTranslation();
  const { user } = useAuthStore();
  const { isMobile } = useResponsive();
  useBreadcrumbs(
    [
      {
        key: ROUTES.HOME,
        title: isMobile ? t('Manage Profile') : t('Home'),
        value: ROUTES.HOME,
      },
      {
        key: ROUTES.MANAGE_PROFILE,
        title: t('Manage account'),
        value: ROUTES.MANAGE_PROFILE,
      },
    ],
    true
  );

  if (!user) return <Preloader />;

  return <ManageProfile />;
};

export default ManageAccountPage;
